import { IDict } from "./types";

export const zh: IDict = {
  "Import Karaoke File": "导入卡拉OK文件",
  "dialogs.import_karaoke.title": "从文件导入卡拉OK",
  "dialogs.import_karaoke.description":
    "导入现有的卡拉OK文件，如带有嵌入歌词的MP3/MP4文件、同名的LRC文件或Karafun文件。",
  optional: "可选",
  Jobs: "任务",
  "No Jobs": "无任务",
  Billing: "账单",
  Credits: "积分",
  "Pay Per Use": "按次付费",
  "Feature Voting": "功能投票",
  "Free Karaoke Left": "剩余免费卡拉OK",
  "Upgrade Now to Create More": "立即升级以创建更多",
  "Storage is Full": "存储已满",
  "Youka is running out of storage space": "Youka 的存储空间不足",
  "Please free up at least 1 GB before creating new karaoke":
    "请释放至少1GB的空间后再创建新的卡拉OK",
  "Click the button to check again": "点击按钮再次检查",
  "No Internet Connection": "无互联网连接",
  "Youka cannot connect to the internet": "Youka 无法连接到互联网",
  "Please make sure you have internet connection": "请确保您已连接到互联网",
  "Update is ready": "更新已准备好",
  "Click the button to update": "点击按钮更新",
  "Library Folder": "库文件夹",
  "Export Folder": "导出文件夹",
  "Sync Model": "同步模型",
  "Max Video Quality": "最大视频质量",
  "Speed / Compression Preset": "速度/压缩预设",
  Change: "更改",
  "dialogs.upgrade.upgrade_to_pro":
    "您需要的功能是Pro计划的一部分，立即升级以解锁该功能。",
  "dialogs.upgrade.upgrade_to_standard":
    "您需要的功能是标准计划的一部分，立即升级以解锁该功能。",
  heads_up: "注意！",
  "dialogs.edit_lyrics.not_supported":
    "您选择的语言目前不支持自动歌词同步。不过，您可以保存进度并使用行级编辑器手动同步歌词。",
  "dialogs.create.title": "创建新的卡拉OK",
  "dialogs.create.description":
    "请填写以下表格以创建新的卡拉OK，您可以使用音频或视频文件，歌词是可选的。",
  "dialogs.edit_lyrics.description":
    "保存后将启动同步过程，您可以在任务选项卡中查看进度",
  "dialogs.upgrade.see_plans": "查看计划",
  "dialogs.upgrade.unlock": "解锁",
  "comps.sync_editor.attach_previous": "附加到上一个单词",
  "comps.sync_editor.attach_next": "附加到下一个单词",
  "comps.plans.title": "选择最适合您需求的计划。您可以随时升级或降级",
  "Font Size": "字体大小",
  Spacing: "间距",
  Outline: "轮廓",
  "Margin Bottom": "底部边距",
  "Max Chars per Line": "每行最大字符数",
  Bold: "加粗",
  Italic: "斜体",
  Shadow: "阴影",
  month: "月",
  songs: "歌曲",
  Title: "标题",
  "Save and Sync": "保存并同步",
  Lyrics: "歌词",
  Update: "更新",
  Playlist: "播放列表",
  Canceling: "取消中",
  Play: "播放",
  "Lyrics Language": "歌词语言",
  "Background Image": "背景图片",
  "Basic Version": "基础版",
  "Standard Version": "标准版",
  "Pro Version": "专业版",
  "Trial Version": "试用版",
  "No Active Plan": "无活动计划",
  "Days Left in Trial": "试用剩余天数",
  Paste: "粘贴",
  "Sync Lyrics": "同步歌词",
  Show: "显示",
  Settings: "设置",
  Retry: "重试",
  "Create Karaoke": "创建卡拉OK",
  Canceled: "已取消",
  Reset: "重置",
  "Edit Video": "编辑视频",
  Download: "下载",
  "Edit Metadata": "编辑元数据",
  "Subtitle Designer": "字幕设计器",
  Export: "导出",
  year: "年",
  Basic: "基础",
  Standard: "标准",
  Pro: "专业",
  Accept: "接受",
  "Add new word": "添加新单词",
  "Add to queue": "加入队列",
  "An unknown error occurred": "发生未知错误",
  Annually: "按年",
  "Are you sure you want to delete this karaoke song?":
    "您确定要删除这首卡拉OK歌曲吗？",
  "Artist Name": "艺术家姓名",
  "Audio or Video File": "音频或视频文件",
  Audio: "音频",
  "Auto Karaoke Generator": "自动卡拉OK生成器",
  "Auto Lyrics Sync": "自动歌词同步",
  "Cancel Plan": "取消计划",
  Cancel: "取消",
  Close: "关闭",
  "Create Karaoke from song": "从歌曲创建卡拉OK",
  "Create Karaoke from local files": "从本地文件创建卡拉OK",
  "Create new karaoke": "创建新的卡拉OK",
  Create: "创建",
  "Current Plan": "当前计划",
  "Dark Mode": "暗模式",
  Decline: "拒绝",
  "Delete word": "删除单词",
  Delete: "删除",
  "Edit Lyrics": "编辑歌词",
  Edit: "编辑",
  "Export to mp3/mp4": "导出为mp3/mp4",
  "Go Back to EULA": "返回EULA",
  "Go back": "返回",
  "Go forward": "前进",
  Home: "主页",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "我接受条款并承诺避免未经授权使用受版权保护的内容",
  Instruments: "乐器",
  Key: "调",
  Library: "库",
  "Light Mode": "亮模式",
  "Line Level Sync": "行级同步",
  "Line Level": "行级",
  "Lyrics (optional)": "歌词（可选）",
  "Lyrics Sync Editor": "歌词同步编辑器",
  Manage: "管理",
  Monthly: "按月",
  "Most popular": "最受欢迎",
  "No new notifications": "无新通知",
  "No results": "无结果",
  "No songs in library": "库中无歌曲",
  "No songs in queue": "队列中无歌曲",
  Notifications: "通知",
  Off: "关闭",
  Or: "或",
  "Plan canceled, will end in": "计划已取消，将在结束",
  "Play word in loop": "循环播放单词",
  "Preparing Youka": "正在准备 Youka",
  "Process 2 karaokes at a time": "同时处理 2 个卡拉OK",
  "Process 5 karaokes at a time": "同时处理 5 个卡拉OK",
  Queue: "队列",
  Ready: "已准备好",
  "Remove from queue": "从队列中移除",
  "Resume plan": "恢复计划",
  "Save and Resync": "保存并重新同步",
  Save: "保存",
  "Saving...": "保存中...",
  Search: "搜索",
  "Select plan": "选择计划",
  "Sign In": "登录",
  "Sign Out": "退出",
  "Sign Up": "注册",
  "Song Name": "歌曲名称",
  "Start typing to search or paste YouTube URL":
    "开始输入以搜索或粘贴 YouTube URL",
  "Start typing to search": "开始输入以搜索",
  "Subtitle Track": "字幕轨道",
  Subtitles: "字幕",
  Tempo: "节奏",
  "Terms and Conditions": "条款和条件",
  "This action cannot be undone.": "此操作无法撤销。",
  "Thumbnail URL": "缩略图 URL",
  "To keep the karaoke fun going, please upgrade":
    "为了保持卡拉OK的乐趣，请升级",
  "Unlock Premium Features with an Upgrade!": "升级以解锁高级功能！",
  "Update Payment Method": "更新付款方式",
  "Upgrade to Pro plan to enable": "升级到专业计划以启用",
  Upgrade: "升级",
  Version: "版本",
  Video: "视频",
  Vocals: "人声",
  "Waiting in queue": "在队列中等待",
  "Word Level Sync": "单词级同步",
  "Word Level": "单词级",
  "You need to accept the EULA to use Youka": "您需要接受EULA才能使用Youka",

  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "您的歌词已成功保存。目前正在重新同步。您可以在通知区域监控进度。一旦重新同步完成，您可以点击“播放”查看更改。",
  "Your trial version of Youka has expired": "您的Youka试用版已过期",
  "dialogs.youtube.title": "安装yt-dlp插件以搜索和播放在线视频",
  "dialogs.youtube.description": "请阅读并接受以下警告，然后启用插件。",
  "dialogs.youtube.agree": "我已阅读并理解上述警告",
  "dialogs.youtube.install": "安装插件",
  "dialogs.youtube.install_success": "插件安装成功",
  "dialogs.youtube.install_success_description": "您现在可以搜索和播放在线视频",
  "dialogs.youtube.install_error": "插件安装失败",
  "alert.youtube.description":
    "在线视频搜索和下载插件（yt-dlp）未预装。要安装，请点击“安装”按钮。",
  "alert.youtube.install": "安装插件",
  "dialogs.settings.enable_youtube": "启用yt-dlp插件",

  "dialogs.youtube.warnings": [
    {
      title: "法律合规",
      description:
        "确保您使用此插件完全符合所有适用法律以及与您互动的平台（如YouTube）的服务条款。",
    },
    {
      title: "版权与许可",
      description:
        "此插件可能允许某些行为（如下载内容），如果使用不当可能会侵犯版权法或违反许可协议。尊重内容创作者的权利，并仅将插件用于合法允许的目的。",
    },
    {
      title: "不代表支持",
      description:
        "启用此插件并不意味着我们公司对其支持或认可。该插件是一个独立的实体，我们不对其操作或使用结果承担责任。",
    },
    {
      title: "用户责任",
      description:
        "您对使用此插件的任何行为承担全部责任。这包括因误用或违反服务条款而导致的任何法律后果。",
    },
    {
      title: "潜在风险",
      description:
        "请注意，插件的误用可能导致账户被封禁或受到相关方或平台的法律行动。",
    },
    {
      title: "知情同意",
      description:
        "启用此插件即表示您已阅读并理解这些警告，并对使用插件的行为承担全部责任。",
    },
  ],
  "model.auto": "自动选择最佳模型。",
  "model.audioshake.transcription":
    "最佳模型，通过转录和对齐，结果优异，仅适用于按次付费和试用用户（耗时最长10分钟）。",
  "model.audioshake":
    "第二佳模型，对齐提供的歌词，错误可能会导致不理想的结果（耗时最长10分钟）。",
  "model.wav2vec2":
    "第三佳模型，对齐提供的歌词，几乎支持所有语言，错误可能会导致不理想的结果（耗时最长30秒）。",
  "model.whisper":
    "第四佳模型，通过转录和对齐，歌词输出可能不准确，但同步效果可以接受（耗时最长2分钟）。",
  "sync.line.instructions": [
    "点击播放按钮播放歌曲并开始同步过程",
    "当听到当前行的第一个单词时点击设置开始按钮",
    "当听到当前行的最后一个单词时点击设置结束按钮",
    "继续直到完成所有行的同步",
  ],
  Undo: "撤销",
  Redo: "重做",
  "Set Start": "设置开始",
  "Set End": "设置结束",
  "dialogs.edit_lyrics.transcription":
    "使用转录模型时，模型会自动转录歌曲并识别歌词，不依赖于提供的歌词。之后，您可以使用同步工具调整歌词。",
  "Duet Editor": "二重唱编辑器",
  "Manual Line Sync": "手动行级同步",
  "New Style": "新风格",
  Style: "风格",
  Singer: "歌手",
  "Style Editor": "风格编辑器",
  Word: "单词",
  Line: "行",
  "Split Line": "拆分行",
  "Upgrade to Enable": "升级以启用",
  upgrade_description:
    "您可以收听或下载已经生成的卡拉OK曲目。但如果想创建更多卡拉OK曲目，需升级。",
  "dialogs.global.no_user.title": "无活动计划",
  "dialogs.global.no_user.description": "请升级到计划以继续",
  "dialogs.global.no_role.title": "无活动计划",
  "dialogs.global.no_role.description": "请升级到计划以继续",
  "dialogs.global.blocked_ip.title": "您的IP被封禁",
  "dialogs.global.blocked_ip.description": "请联系支持",
  "dialogs.global.rate_limit.title": "超出速率限制",
  "dialogs.global.rate_limit.description":
    "您可以切换到按次付费计划以获得无限制访问。",
  "dialogs.global.disk_full.title": "存储已满",
  "dialogs.global.disk_full.description": "请释放一些空间以继续使用Youka",
  "dialogs.global.too_big.title": "音频文件超出大小限制",
  "dialogs.global.too_big.description":
    "请注意，音频文件的最大持续时间不得超过15分钟。",
  Help: "帮助",
  Original: "原始",
  Sort: "排序",
  "sort.date.asc": "创建日期（从旧到新）",
  "sort.date.desc": "创建日期（从新到旧）",
  "sort.title.asc": "标题（从A到Z）",
  "sort.title.desc": "标题（从Z到A）",
  "dialogs.trim.title": "修剪",
  "dialogs.trim.description": "使用波形上的可调边框选择您要保留的歌曲部分。",
  Start: "开始",
  End: "结束",
  Time: "时间",
  Related: "相关",
  preserve_vocals: "保留人声",
  preserve_vocals_description: "启用此选项保留如伴唱等人声。",
  "Separate Audio": "分离音频",
  "Separate Model": "分离模型",
  "Add Lyrics": "添加歌词",
  "Background Image or Video": "背景图片或视频",
  Docs: "文档",
  Watch: "观看",
  Hide: "隐藏",
  "watch.sync.title": "如何轻松修复歌词同步？",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  "watch.review.title": "在Trustpilot上评价Youka",
  Review: "评价",
  "Import Subtitles": "导入字幕",
  Import: "导入",
  "How to use": "使用方法",
  Uppercase: "大写",
  "Open Dual Screen": "打开双屏",
  "Close Dual Screen": "关闭双屏",
  "Trial Expired": "试用已过期",
  "Subtitles Settings": "字幕设置",
  Milliseconds: "毫秒",
  Seconds: "秒",
  Text: "文本",
  Enabled: "已启用",
  Duration: "持续时间",
  Gap: "间隙",
  Offset: "偏移",
  "Min Duration": "最小持续时间",
  "Max Duration": "最大持续时间",
  "Fade In": "淡入",
  "Fade Out": "淡出",
  "plugins.title.title": "歌曲标题",
  "plugins.title.description": "在视频开始时插入歌曲标题",
  "plugins.gap_text.title": "静音间隙文字",
  "plugins.gap_text.description": "在字幕之间的间隙插入文本",
  "plugins.gap_progress_bar.title": "静音间隙进度条",
  "plugins.gap_progress_bar.description": "在字幕之间的间隙插入进度条",
  "plugins.fade.title": "淡入淡出效果",
  "plugins.fade.description": "为字幕添加淡入淡出效果",
  "plugins.offset.title": "偏移",
  "plugins.offset.description": "将字幕偏移一定的秒数",
  "plugins.countdown.title": "静音间隙倒计时",
  "plugins.countdown.description": "在字幕之间的间隙插入倒计时",
  Auto: "自动",
  Subword: "子词",
  Countdown: "倒计时",
  "Restart required": "需要重启",
  "Reindex Library": "重新索引库",
  "Create playlist": "创建播放列表",
  "Are you sure you want to delete?": "您确定要删除吗？",
  "Add to playlist": "添加到播放列表",
  "New playlist": "新播放列表",
  "Remove from this playlist": "从播放列表中移除",
  Songs: "歌曲",
  Playlists: "播放列表",
  Name: "名称",
  Photo: "照片",
  "No playlists": "无播放列表",
  "Welcome to Youka": "欢迎使用Youka",
  "Search songs online": "在线搜索歌曲",
  "create.file.title": "从文件创建卡拉OK",
  "create.file.description":
    "上传您的MP3、MP4或其他文件，立即创建带有同步歌词的卡拉OK视频。",
  "create.online.title": "从在线歌曲创建卡拉OK",
  "create.online.description":
    "搜索在线歌曲或粘贴歌曲URL，立即创建带有同步歌词的卡拉OK视频。",
  "Change Background": "更改背景",
  "Duet Line Split": "拆分二重唱行",
  Both: "两者",
  Custom: "自定义",
  Edited: "已编辑",
  Trimmed: "已修剪",
  Instrumental: "纯音乐",
  "Add Subword": "添加子词",
  "plugins.max_chars.title": "每行最大字符数",
  "plugins.max_chars.description": "限制每行字符数",
  Limit: "限制",
  "Background Box": "背景框",
  Height: "高度",
  Width: "宽度",
  Alpha: "透明度",
  Color: "颜色",
  Duplicate: "复制",
  "Convert to 16x9": "转换为16x9",
  "Resize Video": "调整视频大小",
  "Line Alignment": "行对齐",
  "Shadow Color": "阴影颜色",
  "Outline Color": "轮廓颜色",
  "Active Color": "活动颜色",
  "Secondary Color": "次要颜色",
  "Primary Color": "主要颜色",
  "Auto Alignment": "自动对齐",
  "Auto Color": "自动颜色",
  "Singer 1": "歌手1",
  "Singer 2": "歌手2",
  "Top Row": "顶行",
  "Bottom Row": "底行",
  "Border Style": "边框样式",
  "Font Name": "字体名称",
  "Experimental Subtitles Display": "实验性字幕显示",
  Position: "位置",
  "Timing Indicator": "时间指示器",
  General: "通用",
  Styles: "风格",
  Thumbnail: "缩略图",
  "create.url.title": "从URL创建卡拉OK",
  "create.url.description": "从支持yt-dlp的URL创建卡拉OK",
  "Paste a URL or start typing to search": "粘贴URL或开始输入以搜索",
  Top: "顶部",
  Bottom: "底部",
  Center: "中心",
  "Auto Line Break": "自动拆分行",
  "Fill Color": "填充颜色",
  "Active Line Color": "活动行颜色",
  "Waiting Line Color": "等待行颜色",
  "Set as Default": "设置为默认",
  Default: "默认",
  "Make Default": "设置为默认",
  Image: "图片",
  Pause: "暂停",
  File: "文件",
  "Debug Info": "调试信息",
  "File Type": "文件类型",
  Language: "语言",
  "Reset Settings": "重置设置",
  "Failed to start Youka": "启动Youka失败",
  Legacy: "传统",
  Transcription: "转录",
  Alignment: "对齐",
  Imported: "导入",
  "With Backing Vocals": "带伴唱",
  Stem: "Stem",
  Clear: "清除",
  "Open Directory": "打开目录",
  "Advanced Settings": "高级设置",
  "How to Add a Background Black Box to Subtitles": "如何为字幕添加黑色背景框",
  "How to Adjust the Line Length": "如何调整行长度",
  "How to Cancel Your Subscription": "如何取消订阅",
  "How to Center Subtitles": "如何居中字幕",
  "How to Delete a Karaoke": "如何删除卡拉OK",
  "How to Edit the lyrics": "如何编辑歌词",
  "How to Fix the Sync": "如何修复同步",
  "How to Keep Choirs": "如何保留合唱部分",
  "How to Keep the Original Singer’s Voice": "如何保留原唱歌手的声音",
  "How to Set Up a Duet": "如何设置二重唱",
  "How to Speed Up the Download Process": "如何加快下载过程",
  "How to Transfer Your Karaoke Library to a New Computer":
    "如何将卡拉OK库转移到新电脑",
  "How to Trim a Karaoke Video": "如何剪辑卡拉OK视频",
  FAQ: "常见问题",
  "library.description":
    "访问并管理您创建的所有卡拉OK曲目。编辑、组织和完善您的项目。",
  "How to Change the Background Video": "如何更改背景视频",
  "Auto Size": "自动大小",
  "dialogs.global.no_credits.title": "无可用信用",
  "dialogs.global.no_credits.description": "请充值以继续",
  "Credits are over! Click to buy more": "积分已用完！点击购买更多",
  "How to Add a Line Break": "如何添加换行",
  "dialogs.global.no_user.many_emails_description":
    "由于使用不同的电子邮件地址多次登录，访问已被阻止。请购买订阅以继续。",
  "dialogs.global.no_user.virtual_machine_description":
    "由于您正在使用虚拟机，访问已被阻止。要访问免费试用版，请在标准操作系统上安装 Youka。如果您有订阅，请续订以恢复访问。如果您不需要持续生成卡拉 OK，您可以选择按使用付费计划，确保只有在创建新卡拉 OK 内容时才会收费。",
  "Import Stem": "导入Stem",
  "Active Outline Color": "活动轮廓颜色",
  "Inactive Outline Color": "非活动轮廓颜色",
  "Inactive Line Color": "非活动行颜色",
  "Active Line": "活动行",
  "Inactive Line": "非活动行",
  "End Extra": "结束额外",
  Expand: "展开",
  Collapse: "折叠",
  "Copy Line": "复制行",
  "Copy Word": "复制单词",
  "Cut Line": "剪切行",
  "Cut Word": "剪切单词",
  "Delete Line": "删除行",
  "Delete Subword": "删除子词",
  "Delete Word": "删除单词",
  "Add Line": "添加行",
  "Add Word": "添加单词",
  // "Add Subword": "添加子词",
  "Paste Line": "粘贴行",
  "Paste Word": "粘贴单词",
  "Paste Subword": "粘贴子词",
  "Play Line": "播放行",
  "Play Word": "播放单词",
  "Select Line": "选择行",
  "Manual Sync": "手动同步",
  "Trim Start": "修剪开始",
  "Trim End": "修剪结束",
  "Creating will use 1 credit": "创建将使用1个积分",
  All: "全部",
  "Number of Singers": "歌手数量",
  "Style Mapping": "样式映射",
  "Associate subtitle styles with singers": "将字幕样式与歌手关联",
  "Upper first line": "上方第一行",
  "Upper second line": "上方第二行",
  "Lower first line": "下方第一行",
  "Lower second line": "下方第二行",
  Lock: "锁定",
  "2 Lines": "2行",
  "4 Lines": "4行",
  Static: "静态",
  Dynamic: "动态",
  "Subtitles Type": "字幕类型",
  "Danger Zone": "危险区域",
  Copy: "复制",
  Copied: "已复制",
  "Copy Settings": "复制设置",
  "cta.social.title": "免费获取10个积分！",
  "cta.social.description":
    "在社交媒体上分享一条关于 Youka 的帖子，标记我们，每个平台可赚取 10 个免费积分！",
  "cta.social.description.2":
    "点击访问Youka的Facebook页面，点个赞，分享帖子，并在聊天中发送您的电子邮件以获得10个免费积分！",
  "Merge Line": "合并行",
  Player: "播放器",
  "Key Step": "音调步进",
  "Tempo Step": "节奏步进",
  "Shift Line Forward": "向前移动行",
  "Shift Line Backward": "向后移动行",
  "create.description":
    "从音频或视频文件（MP3、MP4等）创建卡拉OK，或粘贴URL，立即生成带同步歌词的卡拉OK视频。",
  "No file chosen": "未选择文件",
  "Choose File": "选择文件",
  "Watch Quick Start Video": "观看快速开始视频",
  "Export Settings": "导出设置",
  "Import Settings": "导入设置",
  "Video Guides": "视频指南",
  "Quick Start Guide": "快速开始指南",
  "Lyrics Sync Guide": "歌词同步指南",
  Resolution: "分辨率",
  "Subtitles Preset": "字幕预设",
  Preset: "预设",
  Done: "完成",
  "New Style Mapping": "新样式映射",
  Horizontal: "水平",
  Vertical: "垂直",
  Square: "方形",
  New: "新建",
  "New Subtitles Preset": "新的字幕预设",
  "Change Aspect Ratio": "更改纵横比",
  "copyright.title.a": "我接受",
  "copyright.title.b": "音乐使用确认",
  "copyright.description":
    "勾选此框，即表示您确认：(A) 您拥有此视频中包含的所有音乐的权利；或 (B) 该音乐属于公共领域；或 (C) 您已获得所有必要权利持有人的许可，以在 Youka 平台上使用该音乐。",
  "Add Intro Video": "添加介绍视频",
  "dialogs.intro.description": "在卡拉OK的开头添加自定义视频",
  Transition: "过渡",
  Fade: "淡出",
  "Circle Open": "圆形打开",
  "Circle Close": "圆形关闭",
  "Diagonal Open": "对角打开",
  "Diagonal Close": "对角关闭",
  "Smooth Left": "平滑左移",
  "Smooth Right": "平滑右移",
  Squares: "方块",
  Dissolve: "溶解",
  Type: "类型",
  "Song Title": "歌曲标题",
  Artists: "歌手",
  Artist: "歌手",
  "Parse Titles": "解析标题",
  "sort.artist.asc": "歌手（A到Z）",
  "sort.artist.desc": "歌手（Z到A）",
  "Title Style": "标题样式",
  "Artist Style": "歌手样式",
  "Analyse Library": "分析库",
  "No Filter": "无过滤",
  "credits.message_one": "这将使用{{count}}积分",
  "credits.message_other": "这将使用{{count}}积分",
  "credits.badge_one": "{{count}}积分",
  "credits.badge_other": "{{count}}积分",
  "Provide song lyrics to save credits": "提供歌曲歌词以节省积分",
  "Upload to Cloud Library": "上传到云库",
  "Cloud Library": "云库",
  "Open Cloud Library": "打开云库",
};
